import { render } from "./vp-selectlimits.vue?vue&type=template&id=7163e85c"
import script from "./vp-selectlimits.vue?vue&type=script&lang=js"
export * from "./vp-selectlimits.vue?vue&type=script&lang=js"

import "./vp-selectlimits.vue?vue&type=style&index=0&id=7163e85c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__